

import { Component, Mixins } from 'vue-property-decorator';
import RemoveUserButton from '~/components/User/RemoveUserButton.vue';

import LinkedUser from '~/components/LinkedUser.vue';
import { uppercaseFirstCharacter } from '~/helpers';
import { Home } from '~/interfaces/home.interface';
import { MappedOwner } from '~/interfaces/owners.interface';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import { HomesModule } from '~/store/modules/homes';
import { OwnerModule } from '~/store/modules/owners';

@Component({
    components: {
        RemoveUserButton,
        LinkedUser,
    },
})
export default class HomeOwners extends Mixins(UserRightsMixin) {
    get owners(): MappedOwner[] {
        return OwnerModule.owners;
    }

    get homeId(): string {
        return OwnerModule.homeId;
    }

    get areOwnersLoading(): boolean {
        return OwnerModule.isLoading;
    }

    get home(): Home | undefined {
        return HomesModule.currentHome;
    }

    shouldShowRemoveUserButton(user: MappedOwner): boolean {
        return Boolean(this.isAllowed(this.getUserTopologyScope(user), 'removeUser') && this.home);
    }

    getUserTopologyScope(user: MappedOwner) {
        let topology = '';
        switch(user.owner) {
            case '':
                topology = 'netatmo';
                break;
            default:
                topology = user.owner as string;
                break;
        }
        return `Topology${uppercaseFirstCharacter(topology)}`;
    }
}
